import { effect, inject, Injectable, signal } from '@angular/core';
import { Raadgiver } from './raadgiver.model';
import { RaadgiverSearchParams } from './raadgiver-search/raadgiver-search-params.model';
import { RaadgiverDatasource } from '@features/raadgivere/raadgiver.datasource';
import { SimpleApi } from '@core/api/simple.api';

@Injectable({
  providedIn: 'root',
})
export class RaadgivereService {
  simpleApi = inject(SimpleApi);
  datasource = inject(RaadgiverDatasource);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  selectedRaadgiver = signal<Raadgiver | undefined>(undefined);
  activeTab = signal('search');
  mode = signal('update');

  async searchRaadgiver(searchParams: RaadgiverSearchParams) {
    this.selectedRaadgiver.set(undefined);
    this.datasource.searchParams.set(searchParams);
    await this.datasource.loadData();
    if (this.datasource.data().data.length == 1) {
      this.selectRaadgiver(this.datasource.data().data[0]);
      setTimeout(() => {
        this.activeTab.set('detail');
      }, 100);
    }
  }

  async exportData() {
    const blob = await this.simpleApi.getBlob(`/api/admin/raadgivere/excel`, {
      filter: JSON.stringify(this.datasource.searchParams()),
      sortBy: 'raadgiver.fornavn,raadgiver.mellemnavne,raadgiver.efternavn',
    });
    const objectUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', 'Raadgiveroversigt.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  opretRaadgiver() {
    this.mode.set('create');
    this.selectedRaadgiver.set(undefined);
    this.activeTab.set('detail');
  }

  async selectRaadgiverResultRow(raadgiver: Raadgiver) {
    this.mode.set('update');
    await this.selectRaadgiver(raadgiver);

    if (raadgiver) {
      this.activeTab.set('detail');
    }
  }

  async selectRaadgiver(raadgiver: Raadgiver) {
    const r = await this.datasource.getById(raadgiver.id!);
    this.selectedRaadgiver.set(r);
  }
}
